import React from "react";
import { GET_LIST } from "react-admin";
import { Card, Button } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from 'moment-timezone';
import {
  map,
  curry,
  range,
  filter,
  compose,
  isEmpty,
  prop,
  isNil
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Select from "@material-ui/core/Select";
import { Link } from "react-router-dom";
import { parse } from "query-string";

const StartForm = styled.form({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "12rem",
  height: "29rem",
  justifyContent: "space-between"
});

class GpsScheduleStart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      location: 0,
      optDateBegin: null,
      optDateEnd: null,
      month: moment()
        .startOf("month")
        .format("YYYYMMDD")
    };
  }

  async fetchData() {
    const dataProvider = await dataProviderFactory("rest");

    const getLocations = dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const [locations] = await Promise.all([getLocations]);
    const baseLocations = filter(
      compose(isNil, prop("base_location_id")),
      locations.data
    );
    return {
      locations: baseLocations
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const {
      date_start,
      date_end,
      location,
      op_date_begin,
      op_date_end
    } = parse(this.props.location.search);
    if (!isEmpty(this.props.location.search)) {
      await this.updateState(
        date_start,
        date_end,
        parseInt(location, 0),
        op_date_begin !== "null" ? op_date_begin : null,
        op_date_end !== "null" ? op_date_end : null
      );
    } else {
      const startDate = moment()
        .startOf("month")
        .format("YYYYMMDD");

      const endDate = moment()
        .startOf("month")
        .add(2, "month")
        .format("YYYYMMDD");

      await this.updateState(startDate, endDate, 0, null, null, null);
    }
  }

  updateState = async (
    startDate,
    endDate,
    location,
    optDateBegin,
    optDateEnd
  ) => {
    const { locations } = await this.fetchData();

    const numberOfMonths = moment(endDate).diff(moment(startDate), "months");

    this.setState({
      numberOfMonths,
      locations,
      isLoading: false,
      startDate,
      endDate,
      location,
      month: moment(startDate)
        .startOf("month")
        .format("YYYYMMDD"),
      optDateBegin,
      optDateEnd
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });

    if (event.target.name !== "location") {
      this.setState({
        optDateEnd: null,
        optDateBegin: null
      });
    }
  };

  handleChangeOptE = eventDate => {
    this.setState({ optDateEnd: moment(eventDate) });
  };

  handleChangeOptB = eventDate => {
    this.setState({
      optDateBegin: eventDate
    });

    if (!isNil(eventDate) && isNil(this.state.optDateEnd)) {
      const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
      this.setState({
        optDateEnd: newDate
      });
    } else if (!isNil(this.state.optDateBegin) && !isNil(eventDate)) {
      if (moment(eventDate).isSameOrAfter(moment(this.state.optDateEnd))) {
        const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
        this.setState({
          optDateEnd: newDate
        });
      }
    }
  };

  buildMonthSelect = startDate => {
    let begining = moment().startOf("month");

    const recordForMonth = month => ({
      id: month.format("YYYYMMDD"),
      label: month.format("MMMM YYYY")
    });
    let tempMonths = map(
      offset => recordForMonth(begining.clone().add(offset, "month")),
      range(0, 24)
    );

    const existsMonth = filter(
      month => month.id === this.state.month,
      tempMonths
    );
    let months = [];

    if (isEmpty(existsMonth)) {
      months = [
        {
          id: this.state.month,
          label: moment(this.state.month).format("MMMM YYYY")
        }
      ];
    }
    months = months.concat(tempMonths);

    return (
      <React.Fragment>
        <FormControl>
          <InputLabel htmlFor="months-simple">Starting Month</InputLabel>
          <Select
            value={this.state.month}
            onChange={this.handleChange}
            inputProps={{
              name: "month",
              id: "month-simple"
            }}
          >
            {map(month => {
              return (
                <MenuItem key={month.id} value={month.id}>
                  {month.label}
                </MenuItem>
              );
            }, months)}
          </Select>
        </FormControl>

        <FormControl>
          <InputLabel htmlFor="model-simple">Number of Months</InputLabel>
          <Select
            value={this.state.numberOfMonths}
            onChange={this.handleChange}
            inputProps={{
              name: "numberOfMonths",
              id: "number-simple"
            }}
          >
            {map(
              n => (
                <MenuItem key={n} value={n}>
                  {n}
                </MenuItem>
              ),
              range(1, 13)
            )}
          </Select>
        </FormControl>
      </React.Fragment>
    );
  };

  render() {
    const {
      isLoading,
      locations,
      location,
      month,
      optDateBegin,
      optDateEnd,
      numberOfMonths
    } = this.state;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const startDate = month;
    const endDate = moment(month)
      .add(numberOfMonths, "months")
      .format("YYYYMMDD");

    return (
      <Card>
        <StartForm autoComplete="off">
          <h3>Gps Schedule</h3>
          <FormControl>
            <InputLabel htmlFor="location-simple">Location</InputLabel>
            <Select
              value={this.state.location}
              onChange={this.handleChange}
              inputProps={{
                name: "location",
                id: "location-simple"
              }}
            >
              <MenuItem value={0}>
                <em>All Cities</em>
              </MenuItem>
              {map(location => {
                return (
                  <MenuItem key={location.id} value={location.id}>
                    {location.location_name}
                  </MenuItem>
                );
              }, locations)}
            </Select>
          </FormControl>
          {this.buildMonthSelect(this.state.startDate)}
          <br />
          <InputLabel htmlFor="model-simple">Optional Dates</InputLabel>
          <FormControl>
            <CustomDatePicker
              onChange={e => this.handleChangeOptB(e)}
              selectedDate={
                optDateBegin && optDateBegin !== "null"
                  ? moment(optDateBegin).format("YYYY-MM-DD")
                  : null
              }
              label="Date Begin"
              minDate={moment(startDate)}
              maxDate={moment(endDate).format("YYYY-MM-DD")}
            />
          </FormControl>
          <FormControl>
            <CustomDatePicker
              onChange={e => this.handleChangeOptE(e)}
              selectedDate={
                optDateEnd && optDateEnd !== "null"
                  ? moment(optDateEnd).format("YYYY-MM-DD")
                  : null
              }
              label="Date End"
              minDate={moment(optDateBegin).add(1, "day")}
              maxDate={moment(endDate).format("YYYY-MM-DD")}
            />
          </FormControl>
          <Button
            size="small"
            color="primary"
            component={Link}
            to={{
              pathname: `/gps_schedule`,
              search: `?date_start=${startDate}&date_end=${endDate}&location=${location}&op_date_begin=${!isNil(optDateBegin)
                ? moment(optDateBegin).format("YYYYMMDD")
                : null
                }&op_date_end=${!isNil(optDateEnd)
                  ? moment(optDateEnd).format("YYYYMMDD")
                  : null
                }`
            }}
          >
            Next
          </Button>
        </StartForm>
      </Card>
    );
  }
}

export default GpsScheduleStart;



// WEBPACK FOOTER //
// ./src/components/gpsScheduleStart.js